import {
  KiteProgressIndicator,
  KiteAccordion,
  KiteAccordionRow,
} from '@kite/react-kite';

import useFetchOrderTypeChangelog from 'hooks/apiCalls/useFetchOrderTypeChangelog';

import './Changelog.scss';

interface IChangelogProps {
  collateralId?: string;
  className?: string;
}

const Changelog = ({ collateralId, className = '' }: IChangelogProps) => {
  const { data: changelogData, isLoading: isChangelogLoading } =
    useFetchOrderTypeChangelog(collateralId);

  const handleAccordionChange = () => {
    // Handle accordion change
  };

  return (
    <div className={`changelog ${className}`}>
      {isChangelogLoading ? (
        <KiteProgressIndicator
          id="changelog-loading"
          message="Loading changelog..."
          title="Loading"
        />
      ) : changelogData?.changeLogs && changelogData.changeLogs.length > 0 ? (
        <>
          <h2>Changelog</h2>
          <KiteAccordion
            onChange={handleAccordionChange}
            defaultActiveRow={0}
            className="changelog-accordion"
          >
            {changelogData.changeLogs.map((log) => (
              <KiteAccordionRow
                key={log.version}
                id={`version-${log.version}`}
                title={
                  <div className="changelog-header-content">
                    <h3 className="version-title">Version {log.version}</h3>
                    <p className="description-preview">{log.description}</p>
                  </div>
                }
              >
                <div className="changelog-row-content">
                  <span className="changelog-date">
                    Released on{' '}
                    {new Date(log.releasedAt).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </span>
                  {log.detail && log.detail.length > 0 && (
                    <ul className="changelog-detail-list">
                      {log.detail.map((item, idx) => (
                        <li key={idx}>{item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </KiteAccordionRow>
            ))}
          </KiteAccordion>
        </>
      ) : (
        <div className="no-changelog">
          <p>No changelog available for this collateral.</p>
        </div>
      )}
    </div>
  );
};

export default Changelog;
